export const isChatSessionActive = () => {
  const caSessionActive = localStorage.getItem('ca-session');
  if (caSessionActive === 'active') return true;
  return false;
};

export const setChatSession = () => {
  localStorage.setItem('ca-session', 'active');
};

export const removeChatSession = () => {
  localStorage.removeItem('ca-session');
};
